module.exports = __webpack_public_path__ + "static/media/edit-green.e2647f1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/edit-green.svg
// module id = 77
// module chunks = 0